import React from 'react'
import TemplatizedTextField, {
    type TemplatizedTextFieldProps,
} from '@pushly/aqe/lib/components/templatized-text-field/templatized-text-field'

interface ITemplateTitleField extends TemplatizedTextFieldProps {}

const TemplateTitleField = (props: ITemplateTitleField) => {
    return (
        <TemplatizedTextField
            label="Title"
            {...props}
            limits={{
                max: 40,
                aboveMaxMessage: 'Title may be cut off or prevent the Body from showing on some devices.',
                displayMode: 'custom',
            }}
        />
    )
}

export default TemplateTitleField
